import React from 'react';
import './contact-us.css';

const ContactUs = () => {
  return (
    <div className="contact-us-container">
      <header className="contact-header">
        <h1>Contact Us</h1>
        <p>E-Techno Educational and Research Society</p>
      </header>

      <section className="contact-section">
        <h2>We Value Your Interest</h2>
        <p>
          If you have any questions, suggestions, or need assistance, feel free to reach out to us through the following channels:
        </p>
      </section>

      <section className="contact-details">
        <h2>Contact Details</h2>
        <p>
          <strong>Address:</strong> B-3/460, First Floor, Paschim Vihar, New Delhi-110063
        </p>
        <p>
          <strong>Email:</strong> <a href="mailto:contact@etechnoedu.org">contact@etechnoedu.org</a>
        </p>
      </section>

      <section className="contact-social">
        <h2>Follow Us</h2>
        <p>
          You can also follow us on our social media platforms for updates on our programs and activities.
        </p>
      </section>

      <footer className="contact-footer">
        <p>Thank you for supporting our mission to empower education and research!</p>
        <p>&copy; 2024 E-Techno Educational and Research Society. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default ContactUs;
